import {
  IonButton,
  IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonList, IonPopover, IonRow, IonSpinner, IonText
} from '@ionic/react';
import React, { Fragment, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { SelectNetworkConnected } from '../../store/UserSlice';
import ResetPassword from '../ResetPassword/ResetPassword';
import ServerDBContext from '../ServerDBContext/ServerDBContext';
import './LoginCard.scss';

const LoginCard: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [loginMessage, setLoginMessage] = useState('');
  const dbService = useContext(ServerDBContext);
  const [displayResetPassword, setDisplayResetPassword] = useState(false);
  const [displayNeedAccount, setDisplayNeedAccount] = useState(false);
  const [isCapsLockOn, setIsCapsLockOn] = useState(false);
  const networkConnected = useSelector(SelectNetworkConnected);

  const login = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);

    if(networkConnected){
      if(!username) {
        setUsernameError(true);
      } else {
        setUsernameError(false);
      }

      if(!password) {
        setPasswordError(true);
      } else {
        setPasswordError(false);
      }

      if(username && password) {
        setLoginMessage('Logging In');
        dbService?.signIn( username.trim(), password).then(result => {
          if(result.Success) {
            // Note the FellowshipConnect component is monitoring changes to the user state
            // and will update redux appropriately with the login status and current user.
            setUsername('');
            setPassword('');
            setLoginMessage('');
          } else {
            setPassword('');
            setLoginMessage(`Email or Password was not valid.`);
          }
        })
      }
    } else {
      setLoginMessage(`Network Connection Required`);
    }
  };

  const checkCapsLock = (event: KeyboardEvent) => {
    if (event.getModifierState('CapsLock')) {
      setIsCapsLockOn(true);
    } else {
      setIsCapsLockOn(false);
    }
  };

  return (
    <Fragment>
    <IonCard>
      <IonCardHeader color="tertiary" ><IonCardTitle className="ion-text-center">SIGN INTO YOUR GROUP</IonCardTitle></IonCardHeader>
      <form noValidate onSubmit={login}>
          <IonList className="login-card-fields-list">
            <IonItem>
              <IonLabel className="form-label" position="floating">Email</IonLabel>
              <IonInput name="username" type="text" value={username} spellCheck={false} autocapitalize="off" onIonChange={e => setUsername(e.detail.value?.toString()!)}
                required>
              </IonInput>
            </IonItem>

            {formSubmitted && usernameError && <IonText color="danger">
              <p className="ion-padding-start">
                Username is required
              </p>
            </IonText>}

            <IonItem>
              <IonLabel className="form-label" position="floating">Password</IonLabel>
              <IonInput name="password" type="password" value={password} onIonChange={e => setPassword(e.detail.value?.toString()!)} onKeyUp={(event) => checkCapsLock(event.nativeEvent)}>
              </IonInput>
            </IonItem>
            {isCapsLockOn  && <IonText color="danger">
              <p className="ion-padding-start">
                Warning: Caps Lock is ON
              </p>
            </IonText>}
            {formSubmitted && passwordError && <IonText color="danger">
              <p className="ion-padding-start">
                Password is required
              </p>
            </IonText>}
          </IonList>
          <IonGrid>
          <IonRow>
            <IonCol>
              {
                loginMessage === 'Logging In' ? 
                  <IonText className="login-message" color="primary">
                    <IonSpinner name="dots" color="primary"/><br />
                    {loginMessage}
                  </IonText> : 
                  <IonText className="login-message" color="danger">
                    {loginMessage}
                  </IonText>
              }
            </IonCol>
          </IonRow>
           <IonRow>
            <IonCol>
              <IonButton disabled={loginMessage === 'Logging In'} color="tertiary" type="submit" expand="block">Login</IonButton>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol sizeXs="12" sizeSm='6' className='ion-text-center'>
              <IonText color="danger" onClick={() => setDisplayResetPassword(true)}>Forgot Your Password?</IonText>
            </IonCol>
            <IonCol sizeXs="12" sizeSm='6' className='ion-text-center'><IonText color="danger" onClick={() => setDisplayNeedAccount(true)}>Need An Account?</IonText>
              </IonCol></IonRow>
          </IonGrid>
        </form>
    </IonCard>
    <IonPopover
        mode="md"
        isOpen={displayResetPassword}
        onDidDismiss={() => {
            setDisplayResetPassword(false);
        }}
      > 
        <ResetPassword email={username} />
    </IonPopover>
    <IonPopover
        mode="md"
        isOpen={displayNeedAccount}
        onDidDismiss={() => {
            setDisplayNeedAccount(false);
        }}
      > 
        <IonContent class="ion-padding">The group features are designed for family, friends, and churches to create a private community of prayer and Bible reading. To sign up for an account you can either create a group or join a private group with the invite that you have received.</IonContent>
    </IonPopover>
    </Fragment>
  );
};

export default LoginCard;